import React from "react";
import i18n from "i18next";

import { api } from "@/utils/api";
import { evaluateStatusEnum } from "@/utils/enum";

class Evaluate extends React.Component {
  constructor(props) {
    super(props);

    this.state = { data: null };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    api.report
      .getEvaluate({
        reportId: this.props?.rendering?.name,
      })
      .then((response) => {
        this.setState({ data: response });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  evaluate = (buttonStatus) => {
    const { data } = this.state;
    api.report
      .evaluate(null, {
        reportId: this.props?.rendering?.name,
        buttonStatus,
        secureToken: data?.secureToken,
        publicationDate: this.props?.rendering?.fields?.publicDate?.value?.slice(0, 10)?.replace(/-/g, "/"),
        reportTitle: this.props?.rendering?.fields?.title?.value,
      })
      .then((response) => {
        this.fetchData();
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  helpfulClick = (selected) => {
    this.evaluate(
      selected ? evaluateStatusEnum.default : evaluateStatusEnum.helpful
    );
  };

  notHelpfulClick = (selected) => {
    this.evaluate(
      selected ? evaluateStatusEnum.default : evaluateStatusEnum.notHelpful
    );
  };

  render() {
    const { data } = this.state;

    let helpfulSelected = false;
    let notHelpfulSelected = false;

    if (data?.dataExistFlag && data?.contentsDeliveryEvaluationButtonStatus) {
      helpfulSelected =
        data?.contentsDeliveryEvaluationButtonStatus?.buttonStatus ===
        evaluateStatusEnum.helpful;
      notHelpfulSelected =
        data?.contentsDeliveryEvaluationButtonStatus?.buttonStatus ===
        evaluateStatusEnum.notHelpful;
    }

    return (
      <div className="evaluate-container">
        <div className="evaluate-container-title">
          {i18n.t("TCRs0004_evaluate_title")}
        </div>
        {data && (
          <div className="evaluate-container-button">
            <button
              className={`evaluate-container-button-helpful ${
                helpfulSelected ? "evaluate-container-button-selected" : ""
              }`}
              onClick={() => this.helpfulClick(helpfulSelected)}
            >
              <img
                alt=""
                src={require(`@/assets/images/evaluate-helpful-new.svg`)}
              />
              <span>{i18n.t("TCRs0004_evaluate_button_helpful_title")}</span>
            </button>
            <button
              className={`evaluate-container-button-not-helpful ${
                notHelpfulSelected ? "evaluate-container-button-selected" : ""
              }`}
              onClick={() => this.notHelpfulClick(notHelpfulSelected)}
            >
              <img
                alt=""
                src={require(`@/assets/images/evaluate-not-helpful-new.svg`)}
              />
              <span>
                {i18n.t("TCRs0004_evaluate_button_not_helpful_title")}
              </span>
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default Evaluate;
